/* lua.js generated code 0.3.0 */

LevelType = {}
LevelType.isMainLevel = function (levelId) {
    if (levelId > LevelConstans.MAIN_LEVEL_ID_START && levelId <= LevelConstans.MAIN_LEVEL_ID_END) {
        return true
    } else {
        return false
    }
}
LevelType.isEditorLevel = function (levelId) {
    return levelId === LevelConstans.Editor_LEVEL_ID
}
LevelType.isHideLevel = function (levelId) {
    return false
}
LevelType.isDiggerMatchLevel = function (levelId) {
    if (levelId > LevelConstans.DIGGER_MATCH_LEVEL_ID_START && levelId <= LevelConstans.DIGGER_MATCH_LEVEL_ID_END) {
        return true
    } else {
        return false
    }
}
LevelType.isMaydayEndlessLevel = function (levelId) {
    if (levelId > LevelConstans.MAYDAY_ENDLESS_LEVEL_ID_START && levelId <= LevelConstans.MAYDAY_ENDLESS_LEVEL_ID_END) {
        return true
    } else {
        return false
    }
}
LevelType.isRecallTaskLevel = function (levelId) {
    if (levelId > LevelConstans.RECALL_TASK_LEVEL_ID_START && levelId <= LevelConstans.RECALL_TASK_LEVEL_ID_END) {
        return true
    } else {
        return false
    }
}
LevelType.isQixi2015Level = function (levelId) {
    if (levelId > LevelConstans.QIXI2015_LEVEL_ID_START && levelId <= LevelConstans.QIXI2015_LEVEL_ID_END) {
        return true
    } else {
        return false
    }
}
LevelType.isUnlockAreaTaskLevel = function (levelId) {
    // body
    if (levelId > LevelConstans.TASK_FOR_UNLOCK_AREA_START && levelId <= LevelConstans.TASK_FOR_UNLOCK_AREA_END) {
        return true
    } else {
        return false
    }
}
LevelType.isSummerMatchLevel = function (levelId) {
    return levelId > LevelConstans.SUMMER_MATCH_LEVEL_ID_START && levelId <= LevelConstans.SUMMER_MATCH_LEVEL_ID_END
}

LevelType.isWeeklyLevel = function (levelId) {
    return false;
}
LevelType.isPvpLevel = function (levelId) {
    return levelId >= LevelConstans.PVP_LEVEL_ID_S && levelId <= LevelConstans.PVP_LEVEL_ID_E
}
LevelType.isActivityMissionLevel = function (levelId) {
    return false
}
LevelType.isOneStepLevel = function (levelId) {
    return levelId >= LevelConstans.ONE_STEP_LEVEL_ID_S && levelId <= LevelConstans.ONE_STEP_LEVEL_ID_E
}
LevelType.isTimeBlockCollectionLevel = function (levelId) {
    return levelId >= LevelConstans.TIME_BLOCK_LEVEL_ID_S && levelId <= LevelConstans.TIME_BLOCK_LEVEL_ID_E
}
LevelType.isCoinMatchLevel = function (levelId) {
    return levelId >= LevelConstans.COIN_MATCH_LEVEL_ID_S && levelId <= LevelConstans.COIN_MATCH_LEVEL_ID_E
}
LevelType.isGoldActivityLevel = function (levelId) {
    let self = this
    // body
    return levelId >= LevelConstans.ACTIVITY_GOLD_ID_S && levelId <= LevelConstans.ACTIVITY_GOLD_ID_E
}
LevelType.isBaiduXiaoshuLevel = function (levelId) {
    return false;
}

LevelType.isMysteryIslandLevel = function (levelId) {
    let self = this
    return levelId > LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START && levelId <= LevelConstans.MYSTERY_ISLAND_LEVEL_ID_END
}
LevelType.isBuildShipLevel = function (levelId) {
    let self = this
    return levelId >= LevelConstans.BUILD_SHIP_LEVEL_ID_S && levelId <= LevelConstans.BUILD_SHIP_LEVEL_ID_E
}
LevelType.getLevelTypeByLevelId = function (levelId) {
    // return GameLevelType.kMysteryIsland
    if (LevelType.isMainLevel(levelId)) {
        return GameLevelType.kMainLevel
    } else if (LevelType.isHideLevel(levelId)) {
        return GameLevelType.kHiddenLevel
    } else if (LevelType.isDiggerMatchLevel(levelId)) {
        return GameLevelType.kDigWeekly
    } else if (LevelType.isMaydayEndlessLevel(levelId)) {
        return GameLevelType.kMayDay
    } else if (LevelType.isRecallTaskLevel(levelId)) {
        return GameLevelType.kTaskForRecall
    } else if (LevelType.isUnlockAreaTaskLevel(levelId)) {
        return GameLevelType.kTaskForUnlockArea
    } else if (LevelType.isSummerMatchLevel(levelId)) {
        return GameLevelType.kSummerWeekly
    } else if (LevelType.isQixi2015Level(levelId)) {
        return GameLevelType.kMayDay
    } else if (LevelType.isEditorLevel(levelId)) {
        return GameLevelType.kEditor
    } else if (LevelType.isWeeklyLevel(levelId)) {
        return GameLevelType.kWeekly
    } else if (LevelType.isActivityMissionLevel(levelId)) {
        return GameLevelType.kActivityMissionLevel
    } else if (LevelType.isGoldActivityLevel(levelId)) {
        return GameLevelType.kGold
    } else if (LevelType.isPvpLevel(levelId)) {
        return GameLevelType.kPvp
    } else if (LevelType.isOneStepLevel(levelId)) {
        return GameLevelType.kOneStep
    } else if (LevelType.isTimeBlockCollectionLevel(levelId)) {
        return GameLevelType.kTimeBlockCollection
    } else if (LevelType.isCoinMatchLevel(levelId)) {
        return GameLevelType.kCoinMatch
    } else if (LevelType.isMysteryIslandLevel(levelId)) {
        return GameLevelType.kMysteryIsland
    } else if (LevelType.isBuildShipLevel(levelId)) {
        return GameLevelType.kBuildShip
    } else {
        cc.log("unknown level type:levelId=" + tostring(levelId))
        return 0
    }
}
LevelType.isShowRankList = function (levelType) {
    if (_isQixiLevel) {
        return false
    }
    if (levelType === GameLevelType.kMayDay || levelType === GameLevelType.kTaskForRecall || levelType === GameLevelType.kTaskForUnlockArea) {
        return false
    }
    return true
}
LevelType.isShareEnable = function (levelType) {
    return levelType === GameLevelType.kMainLevel || levelType === GameLevelType.kHiddenLevel
}
